import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from "../../../sessionStorage";
import { httpRequest } from "../../../httpRequest";

const getResourceData = async (searchInput) => {
  const accountSessionStorage = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  if (!accountSessionStorage || !accountSessionStorage.account) {
    return null;
  }

  const accountId = accountSessionStorage.account.accountId;
  const url = !searchInput ? `${process.env.REACT_APP_COVR_SERVICES_URL}/api/advisorResource/${accountId}` :
    `${process.env.REACT_APP_COVR_SERVICES_URL}/api/advisorResource/${accountId}/${searchInput}`;

  try {
    return await httpRequest.get(url);
  } catch (ex) {
    return null;
  }
}

const sortItems = (items, rowTitle, totalCount) => {
  if (rowTitle === 'Search Results') {
    return {resourceItems: [...items], totalCount, rowTitle}
  }
  const resourceItems = items.filter(r => r.resourceCategory === rowTitle);
  return {resourceItems: [...resourceItems], totalCount, rowTitle};
}

export { sortItems, getResourceData }


// WEBPACK FOOTER //
// ./src/components/Resource Center/Helpers/index.js